import DatePicker from 'vue2-datepicker'
import custom from '@/custom';
import config from '@/config';
import codes from '@/codes';
import { Switch as cSwitch } from '@coreui/vue';
import vSelect from 'vue-select';
import PictureInput from 'vue-picture-input' // https://github.com/alessiomaffeis/vue-picture-input good boy
import ServiceList from '../../setting/setting.Service.i18n'

//restful api
import { setting } from '@/service/api/setting'

//i18n
import { SetLang } from '@/service/i18n'

let default_opt = function() {
  return {
    perPage: 15,
    currentPage: 1, totalRows: 0,
    sk: '', sv: '', skt: '', opt : {}, adv : false
  }
}

const i18n_fields = {
  EN: [
    { key: 'id', thStyle: 'width: 10%', label: 'No.' },
    { key: 'is_alive', sortable: true, label: 'Status'},
    { key: 'name', sortable: true, label: 'Name'},
    { key: 'list_price', sortable: true, label: 'Public price' },
    { key: 'min_price', label: 'Cost price', sortable: true },
    { key: 'func', label: 'Action', sortable: false, thStyle: 'width: 10%'  },
  ],
  KO: [
    { key: 'id', thStyle: 'width: 10%', label: '#.' },
    { key: 'is_alive', sortable: true, label: '상태'},
    { key: 'name', sortable: true, label: '서비스 이름'},
    { key: 'list_price', sortable: true, label: '공시 가격' },
    { key: 'min_price', label: '비용', sortable: true },
    { key: 'func', label: '더보기', sortable: false, thStyle: 'width: 10%'  },
  ]
}

export default {
  components: { DatePicker, cSwitch, vSelect, PictureInput, ServiceList },
  name : "SettingList",
  props : ["auto_refresh", "enable_new", "view_detail"],
  data: () => ({
    index : 0,
    favicon : '',
    file : {},
    config,
    loading : false,
    lock : true,
    confirm_refresh : false,
    confirm_all : false,
    confirm_info: false,
    confirm_toggle : false,
    confirm_delete : false,
    confirm_save : false,
    type : '',
    toggle : 'password',
    custom,
    codes,
    service_new : false,
    service : {},
    so : default_opt(),
    model : { total : 0, enable : 0, disable : 0,
      license : { data : {}, data_json : { key : {}, info : {} }, list : [] },
      logo : { data : { slogan : '', image : ''} },
      mail : { data : {} },
      rule : { data : { wsfinder : { init : false, is_run : false, cp : 0, url : ''  }, wmds : { init : false, is_run : false, cp : 0, url : '' } } },
      invoice : { data : { issue_day : 1, pay_day : 5 } }
    },
    sync : { interval : 15, stop : false, th : undefined },
    alert : false,
    ko_manual : '',
  }),
  computed: {
    startRow() { return this.so.totalRows - (this.so.currentPage - 1) * this.so.perPage; },
    fields() {
      return i18n_fields[this.i18n]
    },
  },
  methods: {
    async input_favicon(x) {
      let getBase64 = (file) => {
        return new Promise((resolve, reject) => {
          var reader = new FileReader();
          reader.readAsDataURL(file);
          reader.onload = function () {
            resolve(reader.result)
          };
          reader.onerror = function (error) { console.log('Error: ', error); };
        })

      }
      this.file = x
      this.file = Object.assign({}, this.file, { base64 : await getBase64(x) })
      this.favicon = this.file.base64
      // console.log('input_favicon', x, rs)
    },
    redirect_manual() {
      let lang = SetLang(localStorage['UWSS_MANAGER_LANG'] || 'EN');

      if(this.i18n == "EN" || lang == "EN"){
        return this.alert = true;
        // return window.open(`https://${location.hostname == 'localhost' ? 'api.f1secaas.net' : location.host.replace(/^[^\\.]*\./, 'api.')}/downloads/manual/${config.manual}`)
      }
      
      if(this.i18n == "KO" || lang == "KO"){
        let manual = config.manual

        manual = manual.replace('en', 'ko')

        return window.open(`https://${location.hostname == 'localhost' ? 'api.f1secaas.net' : location.host.replace(/^[^\\.]*\./, 'api.')}/downloads/manual/${manual}`)
      }
    },
    cancel() {
      if(this.$refs._list) { this.$refs._list.refresh() }
      this.confirm_toggle = false
    },
    clear_logo() {
      this.model.logo.data = { image : '', slogan : '', support : ''}
      this.image = ''
    },
    logo_change (image) {
      console.log('New picture selected!')
      if (image) {
        console.log('Picture loaded.', image)
        this.image = image
      } else {
        console.log('FileReader API not supported: use the <form>, Luke!')
      }
    },
    async load() {
      let manual = config.manual;

      this.ko_manual = manual.replace('en', 'ko');

      try {
        let so = {
          body : { sort : [{ name : "id", op : "desc" }], or : [], and : [] },
          offset : (this.so.currentPage-1 || 0) * this.so.perPage, limit: this.so.perPage, // 10 은 나중에 변수 처리해야함.
        }

        let rs = await setting.listSetting(so);
        if(rs.error) {
          return this.$toastr.e("load failed", this.$route.name)
        }

        rs.body.forEach(r => {
          let row = {}

          if(r.code == 'license')
          {
            try { r.data.info = JSON.parse(r.data.info) }
            catch (e) { console.error(e) }
            // console.log(r.data.info, 'WTF')
            if(!r.data.info.key) {
              // 하위 호환
              r.data = { info : { key : r.data.info, url : '' }, summary : r.data.summary }
              // console.log('하위 호환', r.data, r.code)
            }
          }

          if(r.code == 'logo') {
            this.image = r.data && r.data.images ? r.data.images : '';
            this.favicon = r.data && r.data.favicon ? r.data.favicon : '';
          }

          if(r.code == 'rule') {
            if(!r.data.wmds) {
              let data = r.data
              delete data.wmds
              delete data.wsfinder
              r.data = Object.assign({}, r.data, { wmds : data })
            }

            if(!r.data.wsfinder) {
              r.data = Object.assign({}, r.data, { wsfinder : this.model.rule.data.wsfinder })
            }
          }

          row[r.code] = r;
          // console.log('row', row, r)
          this.model = Object.assign({}, this.model, row);
        });
      } catch (e) { console.log(e); this.$toastr.e(e.data ? e.data.message || e.data.title : e.statusText) }
    },
    save: async function() {
      try {
        let model = {}
        switch (this.type) {
          case 'license':
            model = Object.assign({}, model, { id : this.model.license.id, data : { key : this.model.license.data.info.key, url : this.model.license.data.info.url, language : this.model.license.data.info.language }})
            break;
          case 'mail':
            model = Object.assign({}, model, { id : this.model.mail.id, data : this.model.mail.data })
            break;
          case 'rule':
            model = Object.assign({}, model, { id : this.model.rule.id, data : this.model.rule.data })
            // if(!model.rule.data.wmds) {
            //   let data = model.rule.data
            //   delete data.wsfinder
            //   delete data.wmds
            //   model.rule.data.wmds = data

            // }
            break;
          case 'logo':
            model = Object.assign({}, model, { id : this.model.logo.id, data :
              {
                image : this.image ? this.image : this.model.logo.data.image,
                slogan : this.model.logo.data.slogan,
                support : this.model.logo.data.support,
                manual : this.model.logo.data.manual,
                favicon : this.favicon ? this.favicon : '',
                help : this.model.logo.data.help ? this.model.logo.data.help : ''
              }
            })
            break;
          case 'invoice':
            model = Object.assign({}, model, { id : this.model.invoice.id, data :
              {
                business_number : this.model.invoice.data.business_number,
                company : this.model.invoice.data.company,
                contact : this.model.invoice.data.contact,
                issuer : this.model.invoice.data.issuer,
                issuer_email : this.model.invoice.data.issuer_email,
                bank_name : this.model.invoice.data.bank_name,
                bank_number : this.model.invoice.data.bank_number,
                swift_code : this.model.invoice.data.swift_code,
                account_holder : this.model.invoice.data.account_holder,
                bank_branch : this.model.invoice.data.bank_branch,
                company_address : this.model.invoice.data.company_address,
                pay_day : this.model.invoice.data.pay_day,
                issue_day : this.model.invoice.data.issue_day,

              }
            })
            // console.log(model)
            break;
          default:
            break;
        }
        if(model == {}) { return this.$toastr.w("reuire", "update type") }
        
        let check_id = '';
        check_id = model.id ? `${await setting.updateSetting(model)}` : `${await setting.insertSetting(model)}`;

        let rs = check_id;
        if(!rs.error) {
          this.$toastr.s('Saved', "soon refresh 3 sec later"); this.list();
          setTimeout(() => location.reload(), 3000)
        } else {
          this.$toastr.e('Save', "failed"); this.list();
        }
      } catch(e) { this.$toastr.e(e.data ? e.data.message ? e.data.message : e : e.statusText); this.list()}
    },
    list() { this.$emit('refresh'); },
  },
  created() { console.log('group.list.vue', 'created'); },
  destroyed() { console.log('group.list.vue', 'destroyed'); },
  mounted() {
    console.log('group.list.vue', 'mounted');
    this.load();
    // if(location.hostname == 'localhost') { setTimeout(() => this.index = 0, 1000) }
  },
}